import { setupResourceStore } from '@/utils'
import BatchItem from '@/resources/BatchItem';

const resource = setupResourceStore(BatchItem)


const state = {
  ...resource.state
};

const getters = {
  ...resource.getters
};

const actions = {
  ...resource.actions
};

const mutations = {
  ...resource.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};